import React from 'react'
import { GpsButton, useLanguage } from '~components'

import { GpsButtonStyle } from './styles'

const GoogleGpsButtonUI = (props) => {
  const {
    handleGPS,
    isGoogleButton,
    googleReady,
    isLoading,
    IconLoadingButton,
    IconButton
  } = props
  const [, t] = useLanguage()
  return (
    <GpsButtonStyle
      className={props.className || ''}
      type='button'
      disabled={(isGoogleButton && !googleReady) || isLoading}
      onClick={handleGPS}
    >
      {isLoading
        ? (
            IconLoadingButton ? <IconLoadingButton /> : '...'
          )
        : (
            props.CustomButton
              ? props.CustomButton
              : (
                <>
                  {IconButton && <IconButton />}
                  <p>{t('USE_MY_LOCATION', 'USE MY LOCATION')}</p>
                </>
                )
          )}
    </GpsButtonStyle>
  )
}

export const GoogleGpsButtonHome = (props) => {
  const gpsButtonProps = {
    ...props,
    UIComponent: GoogleGpsButtonUI
  }
  return (
    <GpsButton {...gpsButtonProps} />
  )
}
